import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v1SearchLocationScreenRecommendedAddresses } from "@be-miniapp/api"

interface UseRecommendedAddressesParams {
  accessToken: string | undefined
  enabled?: boolean
}

const useRecommendedAddresses = ({
  accessToken,
  enabled = true,
}: UseRecommendedAddressesParams) => {
  const { data, isFetched } = useQuery({
    queryKey: ["search-recommended-address"],
    queryFn: async () => {
      return v1SearchLocationScreenRecommendedAddresses()
    },

    enabled: !!accessToken && enabled,
    placeholderData: keepPreviousData,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  })

  return { data, isFetched }
}

export { useRecommendedAddresses }
export type { UseRecommendedAddressesParams }
